import React, { useRef, useEffect, useState, useCallback, useContext } from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
// import { makeStyles } from "@mui/styles"
/* import Link from 'next/link'
import * as config from '../../../next.config' */
// import JsonHomepage from '../Home/JsonHomepage'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
// import IconButton from '@mui/material/IconButton'
import { useRouter } from 'next/router'
// import {useDropzone} from 'react-dropzone'
import { styled } from "@mui/system"
import FormData from 'form-data'
import Dropzone from '../Dropzone'
import { TextField } from '@mui/material'
import LoadingButton from "@mui/lab/LoadingButton"
import axios from "axios";
import * as config from '../../../next.config'
import { printLogs, getCookieValue } from '../../helpers/helpers'
import Dialogs from '../Dialogs/AlertDialog'
import PurchaseOrderConfirmDialog from '../Dialogs/PurchaseOrderConfirmDialog'
import OrderMedicineDialog from '../Dialogs/OrderMedicineDialog '
import FormHelperTxet from '@mui/material/FormHelperText'
import { constants } from '../../../constants'
import TermsContext from "../../../context/Trems"
import Link from 'next/link'
import Address from './Address'
import {getTermsByVocabCodes} from '../../helpers/global/term/term'
const thumbsContainer = {
  display: "flex",
  flexDirection: 'row',
  flexDirection: 'wrap',
  marginTop: 16
}
const Customebtn = styled(LoadingButton)({
  '&.Mui-disabled': {
    color: "grey !important",
    border: "none !important",
    backgroundColor: "#bcbcbc70 !important",

  },
  '&:hover': {

    border: "none"
  },

  backgroundColor: " #02AAB0 !important",
  fontSize: "1.2rem !important",
  width: "236px ",
  border: "none",
  height: "1.0375em",
  boxSizing: "content-box",
  padding: " 16.5px 14px",
  borderRadius: '12px',
  margin: "auto",
  display: "flex",
textTransform:"capitalize",
  '@media (min-width:768px) and (max-width:912px)': {


    backgroundColor: " #02AAB0 !important",
    fontSize: "1.2rem !important",
    width: "320px !important",
    height: "1.0375em",
    boxSizing: "content-box",
    padding: " 16.5px 14px",
    borderRadius: '12px',
    border: "none",
    margin: "auto",
    display: "flex"
  },
  '@media (min-width:913px) ': {
    backgroundColor: " #02AAB0 !important",
    fontSize: "1.2rem !important",
    width: "320px !important",
    height: "1.0375em",
    boxSizing: "content-box",
    padding: " 16.5px 14px",
    borderRadius: '12px',
    border: "none",
    margin: "auto",
    display: "flex"
  },

});
const CustomeFormControl = styled(FormControl)(({ theme, locale }) => ({
  width: "95%",
  margin: 0,
  '& label.Mui-focused': {
    color: "#02AAB0",
  },

  '& .MuiSelect-icon': {
    color: "#02AAB0"
  },
  '& .MuiInputLabel-root': {

    fontSize: "1rem !important",

  },
  '@media only screen and  (min-width:280px){': {
    '& .MuiInputLabel-root': {

      fontSize: "1rem !important",

    },
    width: "100%",
  },
  '@media (min-width:768px) and (max-width:912px)': {
    '& .MuiInputLabel-root': {

      fontSize: "1.2rem !important",

    },
    width: "100%",
  },
  '@media (min-width:913px) ': {
    '& .MuiInputLabel-root': {

      fontSize: "1.2rem !important",

    },
    width: "100%",
  },

}));
const Customeselect = styled(Select)(({ theme, locale }) => ({

  '& .MuiSelect-select': {
    textAlign: locale == "ar" ? "right" : "left"
  },
  '& .MuiSelect-root': {
    borderRadius: "8px",
  },
}));

const CustomeTextField = styled(TextField)({
  border: " 2px solid #eaeaea",
  borderRadius: "8px",
  width: "100%",
  // height: "200px",
  backgroundColor: "#f8f8f8",
  "& .MuiOutlinedInput-root":{
    height:"100%",
    color:"black"
  }
})

function Order(props) {
  const vocabTerms = useContext(TermsContext)
  const [files, setFiles] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [OrderAddress, setOrderAddress] = useState([])
  
  const [filesIds, setfilesIds] = useState([])
  const [OrderTypes, setOrderTypes] = useState([])
  const [fileClasses, setFileClasses] = useState([])
  let limit = 50
  const [DialogData, setDialogData] = useState({
    open: false,
    Type: " ",
    Text: ""
  })
  const [backDialogData, setbackDialogData] = useState({
    open: false,
    Type: " ",
    Text: ""
  })
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    Type: " ",
    Text: "",
    confirmBtnTitle: "",
    loading: false
  })
  const [pageId, setpageId] = useState(1)
  const [entityDetails, setEntityDetails] = useState(null)

  const { t } = useTranslation("common")

  const [inputsValues, setInputsValues] = React.useState({
    entityDetails:null,
    Address: null,
    description: null,
    note:null,
    Address_from:null,
    deliveryDate :null,
    PurchaseOrderType:null,
    DeliveryPrice:null,
    product:null,
    paymentType:null,
    DeliveryId:null,
    entityDetailsId:null,
    errorArray: {
      Address: {value:false, message: t("mandatory-field") },
      entityDetails: { value: false, message: t("mandatory-field") },
      description: { value: false, message: t("mandatory-field") },
      files: { value: false, message: t("mandatory-field") },
      PurchaseOrderType: { value: false, message: t("mandatory-field") },
      note: { value: false, message: t("validateRatingcomment") },
      Address_from: { value: false, message: t("mandatory-field") },
      Addresses: { value: false, message: t("validateAddresses") },
      DeliveryPrice: { value: false, message: "" },
    }
  });

  const callback = useCallback(
    (back) => {
     if (back.files) {
        setFiles(back.files) 
      }
    },
    [files],
  )

  const callbackInputsValues= useCallback(
    (back) => {
      const inputsValuesTemp = { ...inputsValues }
     if(back.Address_from && back.Address_from !=null) {
      inputsValuesTemp["Address_from"]=back.Address_from 
      handleError(inputsValuesTemp,"Address_from");
   
     }
     if(back.Address && back.Address !=null) {
      inputsValuesTemp["Address"]=back.Address
 
      handleError(inputsValuesTemp,"Address");
     }
     if(back.deliveryDate && back.deliveryDate !=null) {
  
      inputsValuesTemp["deliveryDate"]=new Date(back.deliveryDate).valueOf()
   
     }
    
     if(back.DeliveryPrice && back.DeliveryPrice !=null) {
      inputsValuesTemp["DeliveryPrice"]=back.DeliveryPrice
     }
  

     if(back.PurchaseOrderType && back.PurchaseOrderType !=null) {
      inputsValuesTemp["PurchaseOrderType"]=back.PurchaseOrderType

     }
      
     if(back.OrderAddress && back.OrderAddress!=null)
     {
      setOrderAddress(back.OrderAddress)
     }
     if(back.errorArray) {
     if(back.errorArray.PurchaseOrderType ==false)
     {
      inputsValuesTemp["errorArray"].PurchaseOrderType.value=back.errorArray.PurchaseOrderType
     }

     if(back.errorArray.Address ==false && inputsValuesTemp["errorArray"].Address.value!=true)
     {
     inputsValuesTemp["errorArray"].Address.value=back.errorArray.Address
     }
     if(back.errorArray.Address_from ==false)
     {
      inputsValuesTemp["errorArray"].Address_from.value=back.errorArray.Address_from
     }
     if(back.errorArray.DeliveryPrice !=null)
     {
      inputsValuesTemp["errorArray"].DeliveryPrice.value=back.errorArray.DeliveryPrice
     }
     }
     setInputsValues(inputsValuesTemp)
    },
    [inputsValues],
  )

  const handleChange = (e) => {
 
    const value = { ...inputsValues };
    value[e.target.name] = e.target.value;
    setInputsValues(value);
    handleError(value, e.target.name);
  }
  const handleError = (value, name) => {
  
    let formIsValide = true;
    if(name == "Address_from" || name == "Address" ){
       if(   value.Address_from != null  &&  value.Address !=null && value.Address_from == value.Address){
      formIsValide = false;
      value.errorArray.Addresses.value =true
       }
       else {
        value.errorArray.Addresses.value = false;
       }
       if( name == "Address"){
        if(value.Address == null || value.Address == false){
        formIsValide = false;
        value.errorArray.Address.value = true;
       } else {
        
        value.errorArray.Address.value = false;
       }
      }
      if( name == "Address_from"){
       if(value.Address_from == null   && value.PurchaseOrderType && value.PurchaseOrderType.field3 && value.PurchaseOrderType.field3==1 ){
        formIsValide = false;
        value.errorArray.Address_from.value = true;
       }
       else {
        value.errorArray.Address_from.value = false;  
       }
      }
       return formIsValide;
    }
  
    
    // if (name == "Address") {
    // console.log("value",value)
    //   if (value.Address == null || value.Address == false) {
    //     formIsValide = false;
    //     value.errorArray.Address.value = true;
    //   }
    //    else {
    //    value.errorArray.Address.value = false;
    //   }
    //   return formIsValide;
    // }

    // if (name == "entityDetails") {
    //   if (value.entityDetails == null && router.query.type == "medicine" || value.entityDetails == false && router.query.type == "medicine") {
    //     formIsValide = false;
    //     value.errorArray.entityDetails.value = true;
    //   } else {
    //     value.errorArray.entityDetails.value = false;
    //   }
    //   return formIsValide;
    // }
    if (name == "description") {
      // printLogs("value.files", value.files)
      if ((value.description == null || value.description == false) && files.length == 0) {
        formIsValide = false;
        value.errorArray.description.value = true;
      } else {
        value.errorArray.description.value = false;
      }
      return formIsValide;
    }
    if (name == "PurchaseOrderType") {
      if ((value.PurchaseOrderType == null || value.PurchaseOrderType == "")) {
        formIsValide = false;
        value.errorArray.PurchaseOrderType.value = true;
      } else {
        value.errorArray.PurchaseOrderType.value = false;
      }
      return formIsValide;
    }
    // if (name == "Address_from") {

    //   if ((value.Address_from == null   && value.PurchaseOrderType && value.PurchaseOrderType.field3 && value.PurchaseOrderType.field3==1 )) {
    //     formIsValide = false;
    //     value.errorArray.Address_from.value = true;
    //   }
    
    //   else {
    //     value.errorArray.Address_from.value = false;
    //   }
    //   return formIsValide;
    // }

    // if (name == "files") {
    //   if (value.file == null||value.file==false) {
    //       formIsValide = false;
    //       value.errorArray.file.value = true;
    //   } else {
    //       value.errorArray.file.value = false;
    //   }
    //   return formIsValide;
    // }
    if (name == "note") {
    
      if (value.note != null && value.note != "") {
        if (value.note.length < 10) {


          formIsValide = false;
          value.errorArray.note.value = true;
        }
        else {
          value.errorArray.note.value = false;
        }
      } else {
        value.errorArray.note.value = false;
      }
      return formIsValide;
    }
 
  };


  const onDrop = (acceptedData) => {
    printLogs("acceptedData===========>")
    printLogs("acceptedData===========>", acceptedData)
    // handleChangeParent(progConstants.tfImages, acceptedData[0].preview);
    //   setImages(acceptedData[0].preview);
  }


  const handleConfirm = e => {

    e.preventDefault();
    let validateArray = [];

    printLogs("inputsValues",inputsValues)

    if (
      handleError(inputsValues, "Address") &&
      // handleError(inputsValues, "entityDetails") &&
      handleError(inputsValues, "note") &&
      handleError(inputsValues, "description")&&
      handleError(inputsValues, "PurchaseOrderType") &&
      handleError(inputsValues, "Address_from")
    &&inputsValues.errorArray.DeliveryPrice.value==false
    ) {

      validateArray.push(true);
    } else {
      validateArray.push(false);
    }

    if (validateArray.filter(i => i == false).length == 0) {
let data={}

data.purchaseOrderType=inputsValues.PurchaseOrderType
data.Address=OrderAddress.filter(i=>i.id==inputsValues.Address)[0]
data.description=inputsValues.description
data.deliveryDate=inputsValues.deliveryDate
if(inputsValues.Address_from !=null){
  data.Address_from=OrderAddress.filter(i=>i.id==inputsValues.Address_from)[0]
}
if(files.length > 0 ){
  data.files=files
}
if(inputsValues.DeliveryPrice !=null ){
  data.deliveryPrice=inputsValues.DeliveryPrice
}
      setConfirmDialog({
        open: true,
        Type: "success",
        Text: t("confirmText"),
        confirmBtnTitle: t("confirmTitle"),
        data:data
      })
    }
    else {

      handleError(inputsValues, "Address")
      // handleError(inputsValues, "entityDetails")
      handleError(inputsValues, "note")
      handleError(inputsValues, "description")
      handleError(inputsValues, "PurchaseOrderType")
      handleError(inputsValues, "Address_from")
   
      setInputsValues({ ...inputsValues })
    }

  };
  const handleSubmit = async (e) => {
    setLoading(true);
    let checkNull = null

    checkNull = handleError(inputsValues, "Address") 
      && handleError(inputsValues, "description") &&  handleError(inputsValues, "PurchaseOrderType") &&
      handleError(inputsValues, "Address_from") &&  inputsValues.errorArray.DeliveryPrice.value==false
    if (checkNull) {
      let data = {}
      let filesArr = []
      let orders=[]
      let tempLst = ""

      let  DataObject={paymentTypeId:inputsValues.paymentType,orderAddresses:inputsValues.Address, entityDetailsId: parseInt(getCookieValue("login").entityDetailsId),shippingId:0,orderPackageTypeId:inputsValues.PurchaseOrderType.id,discountId: 0}

      if ( inputsValues.Address_from && inputsValues.Address_from != "")  {
        DataObject.orderAddresses_from = inputsValues.Address_from
    }

    if ( inputsValues.product && inputsValues.product != null)  {
    let order={
      
      "paymentTypeId": inputsValues.paymentType,
      "entityDetailsId": inputsValues.product.entityDetailsId,
      "operation": "add",
      "discountId": inputsValues.product.discountId,
      "orderLineItems": [
        {
            "price": inputsValues.product.price*0,
            "productId": inputsValues.product.productUnitPriceId,
            "unitId":  inputsValues.product.unitId,
            "discountId": 0,
            "currencyId":  inputsValues.product.currencyId,
            "quantity": 0,
            "productOfferId": 0
        }
    ]
    }
    if(OrderTypes && OrderTypes.length>0&& OrderTypes.filter(i=>i.code=="order").length>0 ){
      order.orderTypeId =OrderTypes.filter(i=>i.code=="order")[0].id
    }
    if (inputsValues.description != null && inputsValues.description != "") {
      order.orderLineItems[0].description = inputsValues.description
    }
    if ( inputsValues.DeliveryPrice && inputsValues.DeliveryPrice != "")  {
      order.deliveryId=inputsValues.DeliveryId
    }
 
    orders.push(order)
    }
    
    if (inputsValues.description != null && inputsValues.description != "") {
      DataObject.description = inputsValues.description
    }
    if (inputsValues.note != null && inputsValues.note != "") {
      printLogs("D===============>")
      DataObject.note = inputsValues.note
    }
    else {
      DataObject.note =   data.note = "order from web"
    }
  
    if ( inputsValues.deliveryDate && inputsValues.deliveryDate != "")  {
      DataObject.deliveryDate = inputsValues.deliveryDate
    }
    if ( inputsValues.DeliveryPrice && inputsValues.DeliveryPrice != "")  {
      let order2={
        "paymentTypeId": inputsValues.paymentType,
        "entityDetailsId": inputsValues.DeliveryId,
        "operation": "add",
        "discountId": 0,
        "orderLineItems": [
          {
            productId: inputsValues.DeliveryPrice.ProductUnitPriceId,
            price: inputsValues.DeliveryPrice.priceAfterDiscount,
            currencyId: inputsValues.DeliveryPrice.currencyId,
            unitId: inputsValues.DeliveryPrice.unitId,
            quantity: inputsValues.DeliveryPrice.quantity,
            discountId: 0,
            entityDetailsId:parseInt( inputsValues.product.entityDetailsId),
            productOfferId: inputsValues.DeliveryPrice.offerId
              ? inputsValues.DeliveryPrice.offerId : 0,
              distance:inputsValues.DeliveryPrice.distance
          }
      ]
      }
      if(inputsValues.DeliveryPrice.productShippingOffersId !=null){
        order2.orderLineItems[0].productShippingOffersId=inputsValues.DeliveryPrice.productShippingOffersId
        order2.entityDetailsIdForProductShippingOffers= inputsValues.product.entityDetailsId
      }
      if(OrderTypes && OrderTypes.length>0&& OrderTypes.filter(i=>i.code=="shipping").length>0 ){
        order2.orderTypeId =OrderTypes.filter(i=>i.code=="shipping")[0].id
      }
      orders.push(order2)
    }
    if(orders.length>0){
      DataObject.orders=orders

    }
      if (files.length > 0) {
        for (let ele = 0; ele < files.length; ele++) {
          let formData = new FormData();
          formData.append("file", files[ele]);
          formData.append("fileEntityClassId", fileClasses.filter(a=>a.code=="order-package-files")[0].id);
          formData.append("note", "this is by web");
          await fetch(`${config.basePath}/api/Files/post`, {
            method: "POST",
            body: formData
          }).then(async res => {
            let resp = await res.json()

            filesArr.push({ fileId: resp.data.id })
          })
        }
        DataObject.orderPackageFiles=filesArr
     
       
        axios.post(
          `${config.basePath}/api/orders/packages/post`,
          {
            data: DataObject,
            headers: {
              "Content-Type": "application/json",
              "accept-language": router.locale
            }
          }

        ).then(res => {
          setLoading(false);
     
if(!res.data.data.errors){
          if (res.data.data.successful && res.data.data.successful.count > 0) {
            setConfirmDialog({
              open: false
            })
            setDialogData({
              open: true,
              Type: "success",
              Text: t("successtext")
            })
          } else {
            setConfirmDialog({
              open: false
            })
            setDialogData({
              open: true,
              Type: "error",
              Text: res.data.data.unsuccessful.objects[0].message
            })

          }
        }else{
          setConfirmDialog({
            open: false
          })
          setDialogData({
            open: true,
            Type: "error",
            Text: res.data.data.errors.subErrors[0].message
          })
        }

        }).catch(err => (err));
      } else {
        

        axios.post(
          `${config.basePath}/api/orders/packages/post`,
          {
            data: DataObject,
            headers: {
              "Content-Type": "application/json",
              "accept-language": router.locale
            }
          }

        ).then(res => {
          
      
          setLoading(false);
          if(!res.data.data.errors){
      
          if (res.data.data.successful && res.data.data.successful.count > 0) {
            setConfirmDialog({
              open: false
            })
            setDialogData({
              open: true,
              Type: "success",
              Text: t("successtext")
            })

          } else {
            setConfirmDialog({
              open: false
            })
            setDialogData({
              open: true,
              Type: "error",
              Text: res.data.data.unsuccessful.objects[0].message
            })

          }
        }else{
          setConfirmDialog({
            open: false
          })
          setDialogData({
            open: true,
            Type: "error",
            Text: res.data.data.errors.subErrors[0].message
          })
        }
        }).catch(err => (err));
      }
    }

    else {

      // handleError(inputsValues, "entityDetails")
      handleError(inputsValues, "Address")
      handleError(inputsValues, "note")
      //    handleError(inputsValues,"file")
      handleError(inputsValues, "text")
      handleError(inputsValues, "PurchaseOrderType")
      handleError(inputsValues, "Address_from")
   
      setInputsValues({ ...inputsValues })

    }
  }

  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview))
  }, [])
  useEffect(() => {

    let paymentTypeTemp
    getTermsByVocabCodes(["transaction-payment-types","order-types","file-entity-classes"]).then(response=>{

      if(JSON.parse(response).filter(a=>a.vocCode=="transaction-payment-types").length>0){
   let paymentTypesTemp  =  JSON.parse(response).filter(a=>a.vocCode=="transaction-payment-types")
  if( paymentTypesTemp.filter(i=>i.code=="cash").length>0){
       paymentTypeTemp= paymentTypesTemp.filter(i=>i.code=="cash")[0].id
  }
  if(JSON.parse(response).filter(a=>a.vocCode=="order-types").length>0){
    setOrderTypes(JSON.parse(response).filter(a=>a.vocCode=="order-types"))
  }
  if(JSON.parse(response).filter(a=>a.vocCode=="file-entity-classes").length>0){
    setFileClasses(JSON.parse(response).filter(a=>a.vocCode=="file-entity-classes"))
  }
}
    }).catch({})
      axios.post(`${config["basePath"]}/api/globals/systemConfigration/get`, {
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        limit: 100,
        "configKey": ["DistanceMatrixDeliveryId","jazalyConfig"]
      }
    }).then(res => {
       
      // let jazalyproduct=res.data.data.filter(i=>i.configKey=="jazalyproduct")[0].configValue
      // let jazalyEntityDetails=res.data.data.filter(i=>i.configKey=="jazaly-entity-details")[0].configValue
      let DeliveryId=res.data.data.filter(i=>i.configKey=="DistanceMatrixDeliveryId")[0].configValue
      let jazalyConfig=res.data.data.filter(i=>i.configKey=="jazalyConfig")[0].configValue

           let tempInputsValues2={...inputsValues}
           tempInputsValues2["product"]=JSON.parse(jazalyConfig)
           tempInputsValues2["DeliveryId"]=DeliveryId
           tempInputsValues2["paymentType"]=paymentTypeTemp
           setInputsValues({...tempInputsValues2})
          
  
  
    }).catch(err => console.log(err))
  
  
  

  }, [])


  const router = useRouter()
  return (
    <div className={style.SectionContainer}>
      <div className={style.allcard}>
        <div className={style.OrderMedicineDiv}>
          <div className={style.textaboutdoctor1 + " " + style.Blod + " " + style.TealColor}  >{props.type == "medicine" ? t("Jeza3") : t("Jeza3")}</div>
          <div className={style.towOrderMedicineDiv}>
            <PurchaseOrderConfirmDialog open={confirmDialog.open}
              text={confirmDialog.Text}
              type={confirmDialog.Type}
              confirmBtnTitle={confirmDialog.confirmBtnTitle}
              data={confirmDialog.data}
              btnOk={async () => {
                await handleSubmit()        
              }}
              btnCancel={() => {
                setConfirmDialog({
                  open: false
                })
              }}
            />
            <OrderMedicineDialog open={backDialogData.open}
              text={backDialogData.Text}
              type={backDialogData.Type}
              btnDash={() => {
                setTimeout(() => {
                  window.location = config.basePath + constants.dashboardUrl + '/#/orderPackage'
                }, 1000)
              }}
              btnHome={() => {
                router.push("/")
              }}
            />
            <Dialogs open={DialogData.open}
              text={DialogData.Text}
              type={DialogData.Type}
              btnOk={() => {
                setDialogData({
                  open: false
                })
                if (DialogData.Type == "success") {
                  setbackDialogData({
                    open: true,
                    Type: "success",
                    Text: t("backto")
                  })
                }
              }}
            />
            <div>
              <div>
             
             <Address callbackInputsValues={callbackInputsValues} errors={inputsValues.errorArray}/></div>
              <div>
                <Dropzone onDrop={(accepted) => { onDrop(accepted) }} accept={{ 'image/*': [] }} callBack={callback} />
                {inputsValues.errorArray.description.value ? <FormHelperTxet
                  style={{ textAlign: "center" }}
                  error={inputsValues.errorArray.description.value}
                >
                  {inputsValues.errorArray.description.message}
                </FormHelperTxet> : ""}
              </div>
              <div className={style.SectionContainer   + " " + style.paddinglrzero}>
                <div className={style.allcard}>
                  <div className={style.BgComp} >
                    <div className={style.Container}>
                      <div className={style.allcard}>
                        <div className={style.OrAndBorder}>
                          <div className={style.borderbottomor}></div>
                          <div className={style.textaboutdoctor2 + " " + style.Blod + " " + style.textaligncenter}>{t("orand")}</div>
                          <div className={style.borderbottomor}></div>
                        </div>
                      </div>
                    </div>
                    <div className={style.allcard}>
                      <div className={style.towOrderMedicineDiv + " " + style.padding20}>
                        <div>
                          <div className={style.hLine7 + "  " + style.paddingzero + " " + style.Blod + " " + style.TealColor}  >{props.type == "medicine" ? t("Writehere") : t("Writehere2")}</div>
                        </div>
                        <div>
                          <CustomeTextField
                            name="description"
                            multiline
                             rows={10}
                             placeholder={t("defaultValueMedicine")}
                        
                            value={inputsValues.description}
                            onChange={handleChange}
                          />
                          {inputsValues.errorArray.description.value ? <FormHelperTxet
                            style={{ textAlign: "center" }}
                            error={inputsValues.errorArray.description.value}
                          >
                            {inputsValues.errorArray.description.message}
                          </FormHelperTxet> : ""}
                        </div>
                        {/* <div  className={style.hLine7 + "  " + style.paddingzero + " " + style.Blod + " " + style.TealColor}  >{t("WriteUComment")}</div>
                        <div>
                          <div>
                            <CustomeTextField
                            name="note"
                            multiline
                            rows={4}
                            value={inputsValues.note}
                            onChange={handleChange}
                          />
                            {inputsValues.errorArray.note.value ? <FormHelperTxet
                              style={{ textAlign: "center" }}
                              error={inputsValues.errorArray.note.value}
                            >
                              {inputsValues.errorArray.note.message}
                            </FormHelperTxet> : ""}
                          </div>
                        </div> */}
                        <div>
                          <Customebtn loadingPosition="start" loading={loading}
                            onClick={e => handleConfirm(e)} sx={{ color: "white" }} variant="outlined">
                            {t("OrderConfirmation")}
                          </Customebtn>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Order
